import _ from "lodash";

export const findIndexWithGuid = (callDetails: any, guid: any) => {
  let index = _.findIndex(callDetails, (e: any) => e.guid === guid);
  return index;
};

export const findIndexWithOutboundCampaign = (callDetails: any) => {
  let index = _.findIndex(callDetails, (e: any) => e.outboundCampaign === true);
  return index;
};

export const findIndexWithGuidIncoming = (callDetails: any, Incoming: any) => {
  let index = _.findIndex(callDetails, (e: any) => e.guid === Incoming.guid);
  return index;
};

export const forSipFailure = (callDetails: any, fromCaller: any) => {
  let detailIndex = _.findIndex(callDetails, (item: any) => {
    return item.from === fromCaller
  });
  return detailIndex;
};
export const terminateNormal = (callDetails: any, fromCaller: any) => {
  let detailIndex = _.findIndex(callDetails, (item: any) => item.from === fromCaller);
  return detailIndex;
};

export const forUnavailable = (callDetails: any) => {
  let detailIndex = _.findIndex(callDetails, (item: any) => item.isCurrent === true);
  return detailIndex;
};

export const findIndexWithCalltypeandConference = (callDetails: any) => {
  let index = _.findIndex(callDetails, (item: any) => item.callType === "direct" && item.isConference !== true);
  return index;
};

export const startCallTime = (
  state: any
  // incomingDetails: any,
  // currentCallList: any
) => {
  let index: number = state.callDetails.findIndex((e: any) => {
    return e.guid === state.incomingCallDetail.guid;
  });

  if (index !== -1) {
    //CallTimer(state.callDetails, state.incomingCallDetail, state);
    // setInterval(() => {
    //   // state.callDetails[index].timer = timer;
    // }, 1000);
  }
};

export const CallTimer = (state: any, index: any) => {
  let ltime: any = state.callDetails[0]?.callduration ? state.callDetails[0]?.callduration : "00:00:00";

  let ss: any = ltime.split(":");
  let dt = new Date();
  dt.setHours(ss[0]);
  dt.setMinutes(ss[1]);
  dt.setSeconds(ss[2]);
  let dt2 = new Date(dt.valueOf() + 1000);
  let temp = dt2.toTimeString().split(" ");
  let ts = temp[0].split(":");
  let timer: any;
  timer = ts[0] + ":" + ts[1] + ":" + ts[2];

  state.incomingCallDetail.callduration = timer;
  state.callDetails[index].callduration = timer;
};
export const TransferCallTimer = (state: any, index: any) => {
  let ltime: any = state.callDetails[index]?.TransferCallDuration ? state.callDetails[index]?.TransferCallDuration : "00:00:00";

  let ss: any = ltime.split(":");
  let dt = new Date();
  dt.setHours(ss[0]);
  dt.setMinutes(ss[1]);
  dt.setSeconds(ss[2]);
  let dt2 = new Date(dt.valueOf() + 1000);
  let temp = dt2.toTimeString().split(" ");
  let ts = temp[0].split(":");
  let timer: any;
  timer = ts[0] + ":" + ts[1] + ":" + ts[2];

  // state.incomingCallDetail.callduration = timer;
  state.callDetails[index].TransferCallDuration = timer;
};

export const blistenBargeWisperTimer = (state: any) => {
  let ltime: any = state.trackAgentDetail?.Duration ? state.trackAgentDetail?.Duration : "00:00:00";
  let ss: any = ltime.split(":");
  let dt = new Date();
  dt.setHours(ss[0]);
  dt.setMinutes(ss[1]);
  dt.setSeconds(ss[2]);
  let dt2 = new Date(dt.valueOf() + 1000);
  let temp = dt2.toTimeString().split(" ");
  let ts = temp[0].split(":");
  let timer: any;
  timer = ts[0] + ":" + ts[1] + ":" + ts[2];

  state.trackAgentDetail.Duration = timer;
};
